import AxiosService from "@/Services/AxiosService";
import { Inject, Service } from "vue-di-container";

@Service()
export default class Notifications330Service {
    @Inject(AxiosService) public axiosService!: AxiosService;

    public async GetDefaultDates(): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/notifications-330/get-default-dates";
            const result = await this.axiosService.axiosInstance.get(url);
            return result.data.result;
        } catch (exception) {
            return false;
        }
    }

    public async GetOperatorTenants(): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/notifications-330/get-operator-tenants";
            const result = await this.axiosService.axiosInstance.get(url);
            return result.data.result;
        } catch (exception) {
            return false;
        }
    }

    public async GetMonitorDashboardOptions(): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/notifications-330/get-monitor-dashboard-options";
            const result = await this.axiosService.axiosInstance.post(url, {});
            return result.data.result;
        } catch (exception) {
            return false;
        }
    }

    public async GetKpis(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/notifications-330/get-kpis";
            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data.result;
        } catch (exception) {
            return false;
        }
    }

    public async GetComplaintsStatuses(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/notifications-330/get-complaints-statuses";
            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (exception) {
            return false;
        }
    }

    public async GetComplaintsFrequencyPerSender(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/notifications-330/get-complaints-frequency-per-sender";
            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (exception) {
            return false;
        }
    }

    public async GetComplaintsTimeline(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/notifications-330/get-complaints-timeline";
            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (exception) {
            return false;
        }
    }

    public async GetComplaintFrequencyPerSenderDetails(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/notifications-330/get-complaints-frequency-per-sender-details";
            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (exception) {
            return false;
        }
    }

    public async ExportComplaintFrequencyPerSenderDetails(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/notifications-330/export-complaints-frequency-per-sender-details";
            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (exception) {
            return false;
        }
    }

    public async GetComplaintFrequencySenderNames(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/notifications-330/get-complaint-frequency-sender-names";
            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (exception) {
            return false;
        }
    }

    public async GetComplaintFrequencyClientNames(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/notifications-330/get-complaint-frequency-client-names";
            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (exception) {
            return false;
        }
    }

    public async GetComplaintsTimelineDetails(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/notifications-330/get-complaints-timeline-details";
            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (exception) {
            return false;
        }
    }

    public async ExportComplaintsTimelineDetails(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/notifications-330/export-complaints-timeline-details";
            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (exception) {
            return false;
        }
    }

    public async GetComplaintsTimelineSenderNames(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/notifications-330/get-complaints-timeline-sender-names";
            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (exception) {
            return false;
        }
    }

    public async GetComplaintsTimelineClientNames(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/notifications-330/get-complaints-timeline-client-names";
            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (exception) {
            return false;
        }
    }

    public async GetComplaintsStatusesDetails(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/notifications-330/get-complaints-statuses-details";
            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (exception) {
            return false;
        }
    }

    public async ExportComplaintsStatusesDetails(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/notifications-330/export-complaints-statuses-details";
            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (exception) {
            return false;
        }
    }

    public async GetComplaintsStatusesSenderNames(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/notifications-330/get-complaints-statuses-sender-names";
            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (exception) {
            return false;
        }
    }

    public async GetComplaintsStatusesClientNames(payload: any): Promise<any> {
        try {
            const url =
                window.$config.HostName +
                "api/monitor-dashboard/notifications-330/get-complaints-statuses-client-names";
            const result = await this.axiosService.axiosInstance.post(url, payload);
            return result.data;
        } catch (exception) {
            return false;
        }
    }
}
